module.exports = __webpack_public_path__ + "img/totalmeetings50.56b6f2fd.png";